import { useAuthContext } from './adminAuthHook'
import { getAllConfigurations } from '../redux/reducers/configSlice'
import { useDispatch } from 'react-redux';

export default function PackagesHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { admin } = useAuthContext()
    const getConfigurations=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/admin/configurations/get`,{
          headers:{
            'Authorization': `Bearer ${admin.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllConfigurations(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getConfigurations}
}
